import {
	type EagleModules,
	mergeDynamicEagerDefaultExports
} from '../../app/core/helpers/i18n';

const modules: EagleModules = import.meta.glob('./*.ts', { eager: true });

export default mergeDynamicEagerDefaultExports(modules);
